import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Box,
  Typography,
  Divider,
} from "@mui/material";

import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  HEARTBEAT_INTERVAL_LABEL,
  OUTPUT_FORMAT,
  SAMPLING_RATE_LABEL,
  ENRICHMENT_LEVEL_LABEL,
  TIMESTAMP_TYPE,
} from "../../Constants/Constants";

function SelectComponent({
  labelName,
  defaultValue,
  data,
  onChangeSelect,
  variant,
  width,
  size,
  disabled,
  removeLabel,
  formControlStyle,
  style,
  name,
  getTooltipText,
  noLabelDisplay,
  isAddFramework,
  onScroll,
}) {
  /* istanbul ignore next */
  const handleChange = (e) => {
    onChangeSelect(e.target.value, name);
  };
  /* istanbul ignore next */
  const MenuProps = {
    sx: {
      zIndex: 1500,
    },
    PaperProps: {
      style: {
        maxHeight: "200px",
      },
      onScroll,
    },
  };

  const renderValue = (value) => {
    let displayValue = value;
    switch (labelName) {
      case OUTPUT_FORMAT:
      case TIMESTAMP_TYPE: {
        const item = data?.find((val) => val.value === value);
        displayValue = item?.label ?? "";
        break;
      }

      case HEARTBEAT_INTERVAL_LABEL:
        displayValue = `${value} sec`;
        break;
      case SAMPLING_RATE_LABEL:
        displayValue = `${value}%`;
        break;
      case ENRICHMENT_LEVEL_LABEL: {
        const item = data?.find(
          (val) => val.value.toLowerCase() === value.toLowerCase(),
        );
        displayValue = item ? item.label : value;
        break;
      }
      default:
        displayValue = value;
    }
    if (noLabelDisplay) {
      const item = data?.find(
        (val) =>
          typeof val?.value === "string" &&
          typeof value === "string" &&
          val.value.toLowerCase() === value.toLowerCase(),
      );

      displayValue = item?.label;
    }
    return <Typography>{displayValue}</Typography>;
  };

  /* istanbul ignore next */
  return (
    <FormControl variant={variant} size={size} sx={formControlStyle}>
      <InputLabel
        id="demo-simple-select-standard-label"
        sx={{
          width: "110%",
        }}
      >
        {labelName}
      </InputLabel>
      <Select
        name={name}
        sx={style}
        value={defaultValue}
        onChange={handleChange}
        label={labelName}
        MenuProps={MenuProps}
        renderValue={renderValue}
        disabled={disabled}
        style={{ width }}
      >
        {data?.map((val) => {
          const tooltipForOption =
            typeof getTooltipText === "function"
              ? getTooltipText(val.value)
              : "";
          return (
            <MenuItem
              key={val.value}
              value={val.value}
              sx={
                isAddFramework
                  ? {
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }
                  : undefined
              }
            >
              <span>{val.label}</span>

              {tooltipForOption && (
                <Tooltip title={tooltipForOption}>
                  <InfoOutlinedIcon
                    sx={{
                      fontSize: 16,
                      cursor: "pointer",
                      color: "#1976d2",
                      ml: "2px",
                    }}
                  />
                </Tooltip>
              )}
              {isAddFramework && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    clear: "both",
                    fontSize: "14px",
                    color: "rgba(90, 90, 90, 1)",
                    width: "100%",
                    paddingBottom: "10px",
                    borderBottom: "1px solid #c4c4c4",
                  }}
                >
                  {val?.category} {val?.playerDescription && "•"}{" "}
                  {val?.playerDescription} {val?.adFrameworkName && "•"}{" "}
                  {val?.adFrameworkName}
                </Box>
              )}
              <Divider />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default SelectComponent;
